
import { GET_AP_CPU, GET_AP_CPU_FAIL, GET_AP_CPU_SUCCESS, GET_AP_SESSION_DURATION, GET_AP_SESSION_DURATION_FAIL, GET_AP_SESSION_DURATION_SUCCESS, GET_DOWNLINK_RATE_GRAPH, GET_DOWNLINK_RATE_GRAPH_FAIL, GET_DOWNLINK_RATE_GRAPH_SUCCESS, GET_UPLINK_RATE_GRAPH, GET_UPLINK_RATE_GRAPH_FAIL, GET_UPLINK_RATE_GRAPH_SUCCESS } from '../../constants/graphConstants/sessionDurationsGraphConstants';
/**
 * Reducer function for managing AP dashboard data session durations graph .
 *
 * @param {object} state - Current state of the user login.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const apSessionDurationReducer = (
	state = {
		loading: false,
		apDashSessionDurationstats: {},
		error: null,
	},
	action
) => {
	switch (action.type) {
		case GET_AP_SESSION_DURATION:
			return {
				...state,
				apDashSessionDurationstats: {},
				loading: true,
				error: null,
			};
		case GET_AP_SESSION_DURATION_SUCCESS:
			return {
				...state,
				apDashSessionDurationstats: action.payload,
				loading: false,
				error: null,
			};
		case GET_AP_SESSION_DURATION_FAIL:
			return {
				...state,
				apDashSessionDurationstats: {},
				error: action.payload,
				loading: false,
			};
		default:
			return state;
	}
};
export const apCpuReducer = (
	state = {
		loading: false,
		apCpuStats: {},
	},
	action
) => {
	switch (action.type) {
		case GET_AP_CPU:
			return {
				...state,
				apCpuStats: {},
				loading: true,
			};
		case GET_AP_CPU_SUCCESS:
			return {
				...state,
				apCpuStats: action.payload,
				loading: false,
			};
		case GET_AP_CPU_FAIL:
			return {
				...state,
				apCpuStats: {},
				error: action.payload,
				loading: false,
			};
		default:
			return state;
	}
};
export const uplinkRateGraphReducer = (
	state = {
		loading: false,
		upRateStats: {},
		error: null,
	},
	action
) => {
	switch (action.type) {
		case GET_UPLINK_RATE_GRAPH:
			return {
				...state,
				upRateStats: {},
				loading: true,
				error: null,
			};
		case GET_UPLINK_RATE_GRAPH_SUCCESS:
			return {
				...state,
				upRateStats: action.payload,
				loading: false,
				error: null,
			};
		case GET_UPLINK_RATE_GRAPH_FAIL:
			return {
				...state,
				upRateStats: {},
				error: action.payload,
				loading: false,
			};
		default:
			return state;
	}
};
export const downlinkRateGraphReducer = (
	state = {
		loading: false,
		downRateStats: {},
	},
	action
) => {
	switch (action.type) {
		case GET_DOWNLINK_RATE_GRAPH:
			return {
				...state,
				downRateStats: {},
				loading: true,
			};
		case GET_DOWNLINK_RATE_GRAPH_SUCCESS:
			return {
				...state,
				downRateStats: action.payload,
				loading: false,
				error: null,
			};
		case GET_DOWNLINK_RATE_GRAPH_FAIL:
			return {
				...state,
				downRateStats: {},
				error: action.payload,
				loading: false,
			};
		default:
			return state;
	}
};

